import React, { useState, useEffect } from "react";
import {
  Upload,
  FileText,
  CheckCircle,
  XCircle,
  AlertCircle,
  Download,
  Target,
  TrendingUp,
  Award,
  Zap,
  Mail,
  Briefcase,
  User,
} from "lucide-react";
import Footer from "../component/Home/Footer";
import Header from "../component/Home/Header";
import axios from "../axios";
import { useLocation, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { FaArrowRightLong } from "react-icons/fa6";
import ATSPlans from "./ATSPlans";
import { asyncGetMyIp } from "../action/paymentAction";
import { useDispatch } from "react-redux";

const AtsPublic = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleNavLinkClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // section.scrollIntoView({ behavior: "smooth" });
      const scrollOffset = 0;
      const topOffset =
        section.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  };

  useEffect(() => {
    dispatch(asyncGetMyIp());
  }, []);

  return (
    <>
      <div className="animated-gradient" style={{ minHeight: "100vh" }}>
        {location.pathname === "/evaluate-your-resume" && <Header />}
        {/* Hero Section */}
        <div className="placed_candidate_banner_container">
          <div className="row">
            <video muted autoPlay loop controls={false}>
              <source src="/ats-pub-banner.mp4" />
            </video>
            <div className="placed-candidate-hero-overlay"></div>
            <div className="placed-candidate-hero-content">
              <h2>
                AI-Powered <span>ATS</span> Resume Analyzer
              </h2>
              <h4>Smarter resumes. Faster shortlists. Better opportunities.</h4>
              <p style={{fontWeight:"400", letterSpacing:"0px"}}>
                Our AI-powered ATS Resume Analyzer helps you stand out in a crowded job market.
                From keyword optimization to ATS compatibility checks, it ensures your resume
                meets recruiter expectations. Get actionable insights, improve your chances of
                getting shortlisted, and move closer to your dream career with every application.
              </p>
              <div className="placed-candidate-banner-btntray">
                <button onClick={()=>{handleNavLinkClick("section-ats-plans")}} className="neo-xnmrph-btn-blue">Get Started for Free</button>
                <button onClick={()=>{navigate("/ats")}} className="neo-xnmrph-btn-orange" style={{background:"#ff8000"}}>ATS User Login</button>
              </div>
            </div>
          </div>
        </div>
        <ATSPlans />
      </div>
    </>
  );
};

export default AtsPublic;